
export const checkIfDateWithinPastThreeMonths = (date) => {
    date = new Date(date)
    let threeMonthsAgo = new Date(new Date().setMonth(new Date().getMonth() - 3));
    return (date > threeMonthsAgo)
}

export const checkIfCardExpiresWitihinTwoMonths = (card) => {
    let expirationDate = new Date(card.ValidTo);
    let twoMonthsAhead = new Date(new Date().setMonth(new Date().getMonth() + 2));
    return (twoMonthsAhead > expirationDate)
}

export const checkIfCardExpired = (card) => {
    let expirationDate = new Date(card.ValidTo)
    let today = new Date()
    today.setHours(0, 0, 0, 0);
    return (today > expirationDate)
}
